import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Observable, takeUntil } from 'rxjs';
import { LoginService } from 'src/app/services/login.service';
import { AppConstants } from '../../app.constants';
import { FilterModel } from './filter-model';
import { AppUtils } from '../../app.utils';

@Component({
  selector: 'ness-local-filter',
  templateUrl: './local-filter.component.html'
})
export class LocalFilterComponent implements OnDestroy {
  @Input() disableButton: boolean;
  fieldDivisions$: Observable<ServerModels.ENESS_REF_FieldDivisions[]> = this.loginService.fieldDivisions$;
  @Output() filterModel: EventEmitter<FilterModel> = new EventEmitter<FilterModel>();
  filterValues: FilterModel;
  iconDown: string = 'fa-caret-square-down';
  iconUp: string = 'fa-caret-square-up';

  private _unsubscribe$: Subject<void> = new Subject<void>();
  private _cgicCodeFilter: string;
  private _startDate: Date;
  private _endDate: Date;
  private _storageKey: string;
  private _duration: number;
  private _dateFilterVerbiage: string;

  constructor(private loginService: LoginService) { }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  get cgicCode(): string {
    return this._cgicCodeFilter;
  }

  set cgicCode(code: string) {
    this._cgicCodeFilter = code;
  }

  get dateFilterVerbiage(): string {
    return this._dateFilterVerbiage;
  }

  set dateFilterVerbiage(txt: string) {
    this._dateFilterVerbiage = txt;
  }

  get duration(): number {
    return this._duration;
  }

  set duration(days: number) {
    this._duration = days;
  }

  get endDate(): Date {
    return this._endDate;
  }

  set endDate(dt: Date) {
    this._endDate = dt;
  }

  get startDate(): Date {
    return this._startDate;
  }

  set startDate(dt: Date) {
    this._startDate = dt;
  }

  @Input() set storageKey(key: string) {
    if (key) {
      this._storageKey = key;
      let fm: any;
      if (fm = JSON.parse(sessionStorage.getItem(key))) {
        this.cgicCode = fm._cgicCode;
        this.dateFilterVerbiage = fm._dateFilterVerbiage;
        this.duration = fm._duration;
        this.startDate = new Date(fm._startDate);
        this.endDate = new Date(fm._endDate);
      }
    }
  }

  get yearRange(): string {
    let currentYear = new Date().getFullYear().toString();
    return `${AppConstants.defaultFilterYearRangeStart}:${currentYear}`;
  }

  public applyFilters(): void {
    if (!this.startDate)
      this.startDate = new Date("1/1/1900 12:00:00");
    if (!this.endDate)
      this.endDate = new Date();
    if (!this.duration)
      this.duration = AppConstants.filterDateDurationDays;

    this.filterValues = new FilterModel(this.cgicCode, this.duration, this.dateFilterVerbiage, this.startDate, new Date(this.endDate.setHours(23, 59, 59, 999)));
    sessionStorage.setItem(this._storageKey, JSON.stringify(this.filterValues));
    this.filterModel.emit(this.filterValues);
  }

  public static createFilterModel(storageKey: string, duration: number, dateFilterVerbiage?: string): FilterModel {
    let fm: any;
    if (fm = JSON.parse(sessionStorage.getItem(storageKey))) {
      return new FilterModel(fm._cgicCode, fm._duration, fm._dateFilterVerbiage, fm._startDate, fm._endDate);
    } else {
      let filterModel: FilterModel = new FilterModel(AppUtils.userCGICCode(), duration, dateFilterVerbiage);
      sessionStorage.setItem(storageKey, JSON.stringify(filterModel));
      return filterModel;
    }
  }
}
